/*                                                   */
import { untrack } from "svelte";

type MayGetEventDetails<T> = T extends CustomEvent<infer U> ? U : T extends Event ? never : T;

interface DispatchOptions extends EventInit {
  alias?: string[];
}

/**
 *
 *
 *
 *
 *
 */
export interface EventDispatcher<EventMap extends Record<string, any>, Sync extends boolean> {
  /*                    */
  /*                                                                                                              */
  /*                                                                                                                                    */
  <Type extends keyof EventMap>(
    ...args: null extends MayGetEventDetails<EventMap[Type]>
      ? [
          type: Type,
          parameter?: MayGetEventDetails<EventMap[Type]> | null | undefined,
          options?: DispatchOptions,
        ]
      : undefined extends MayGetEventDetails<EventMap[Type]>
        ? [
            type: Type,
            parameter?: MayGetEventDetails<EventMap[Type]> | null | undefined,
            options?: DispatchOptions,
          ]
        : [type: Type, parameter: MayGetEventDetails<EventMap[Type]>, options?: DispatchOptions]
  ): Sync extends true ? boolean : Promise<boolean>;
}

const getEvent = <T>(type: T, eventInit: CustomEventInit): CustomEvent =>
  new CustomEvent(type as string, eventInit);

/**
 *
 *
 *
 *
 *
 *
 */
export function useEventDispatcher<Events extends Record<string, any>, Sync extends boolean = true>(
  host: HTMLElement,
  sync: Sync = true as Sync,
): EventDispatcher<Events, Sync> {
  const dispatcherImplementation: EventDispatcher<Events, true> = (...args) => {
    const [type, parameter, options] = args;
    const { alias = [], ...eventOptions } = { ...options };

    const eventInit: CustomEventInit = {
      bubbles: true,
      cancelable: true,
      composed: true,
      ...eventOptions,
      detail: parameter,
    };

    const results = [untrack(() => host.dispatchEvent(getEvent(type as string, eventInit)))];
    alias.map((t) => results.push(untrack(() => host.dispatchEvent(getEvent(t, eventInit)))));

    /*                                                      */
    return !results.includes(false);
  };

  if (sync) return dispatcherImplementation as never;

  const asyncDispatcher = (
    disp: EventDispatcher<Events, true>,
    ...args: Parameters<typeof dispatcherImplementation>
  ): Promise<boolean> => new Promise((r) => setTimeout(() => r(disp(...args)), 0));

  return asyncDispatcher.bind(null, dispatcherImplementation) as never;
}
